// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3SQnA","detailsBorder":"styles_detailsBorder__1_xVn"};